"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsAccountId = void 0;
const class_validator_1 = require("class-validator");
const ExactLength_decorator_1 = require("../generic/ExactLength.decorator");
const IsNumeric_decorator_1 = require("../generic/IsNumeric.decorator");
const combineDecorators_1 = require("../utils/combineDecorators");
/**
 * Validates on the following properties:
 * - string
 * - is numeric
 * - Length of 9 or 10 (depending on acceptMissingLeadingZero)
 * ## Valid Example
 * `0172198189`
 */
const IsAccountId = ({ acceptMissingLeadingZero } = {
    acceptMissingLeadingZero: false,
}) => (0, combineDecorators_1.combineDecorators)((0, class_validator_1.IsString)(), (0, IsNumeric_decorator_1.IsNumeric)(), acceptMissingLeadingZero ? (0, combineDecorators_1.combineDecorators)((0, class_validator_1.MinLength)(9), (0, class_validator_1.MaxLength)(10)) : (0, ExactLength_decorator_1.ExactLength)(10));
exports.IsAccountId = IsAccountId;
